// Stable DOM attribute names used by views and browser tests.

export const DOM_ATTRIBUTE = {
  action: "data-action",
  role: "data-role",
  palette: "data-palette",
} as const;
